import {useModalStore} from "../../../store/useModal";
import {CustomModal} from "../ModalComponent/ModalComponent";

export const BaseModal = () => {
    const {modalModel, closeModal} = useModalStore();
    const {title, content} = modalModel || {};

    return <CustomModal isOpen={!!modalModel} title={title} onClose={closeModal} content={content}/>
}
